import { IonProgressBar, IonLoading, IonCardHeader, IonCardTitle, IonCardSubtitle, IonRange, IonCardContent, IonSpinner, IonChip, useIonRouter, IonGrid, IonText, IonImg, IonAlert, IonFabButton, IonFab, IonSearchbar, IonInfiniteScrollContent, IonInfiniteScroll, IonIcon, IonRefresherContent, IonRefresher, IonBackButton, IonButton, IonButtons, IonCard, IonCheckbox, IonCol, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonList, IonPage, IonRow, IonTitle, IonToolbar, useIonViewWillEnter } from "@ionic/react";
import React, { useState, useEffect } from "react";
import { heart } from 'ionicons/icons';
import { RouteComponentProps } from "react-router-dom";
import { Dialog, ConfirmResult } from '@capacitor/dialog';

import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { handleRouteError } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert, showConfirm } from '../components/Alert';
import ContentMini from '../components/ContentMini';
import { ContentInfo, ContentInterface, ContentUpdateInt, ItemInfo, CommentInfo, CreateContentInfo, ContentDetail, CountNum } from '../data/item';

import './Main.css';  

interface BoostProp extends RouteComponentProps<{
    id : any
    }> 
{}


const BoostPost : React.FC<BoostProp> = ({match}) => {
    const [showLoading, setShowLoading] = useState(false);
    const [content, setContent] = useState<ContentInfo>(CreateContentInfo(0, "", "", "/assets/img/avt.jpg"));
    const [tokens, setTokens] = useState(0);
    const [amount, setAmount] = useState("");
    const [multiplayer, setMultiplier] = useState(0.0);
    const [boosted, setBoosted] = useState(false);
    const [initialAmt, setInitialAmt] = useState(0);
    const [amountLeft, setAmountLeft] = useState(0);
    const [createdTime, setCreatedTime] = useState("");
    const [paused, setPaused] = useState(false);
    const [reached, setReached] = useState(0);

    const router = useIonRouter();

    useIonViewWillEnter(() => {
        getData();
    });

    // need to refresh
    useEffect(() => {
        // init
        getData();
    },[match.params.id]);

    const getData = async () => {

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: match.params.id
        }

        var server = new NServer();
        await server.getList("nc_boost_info", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            setContent(server.data.content);
            setTokens(server.data.tokens);
            setMultiplier(server.data.multiplier);

            let boosted = server.data.boosted == 1;
            setBoosted(boosted);

            if (boosted)
            {
                // set remaining data
                setInitialAmt(server.data.init_amount);
                setAmountLeft(server.data.left);
                setCreatedTime(server.data.created);
                setPaused(server.data.paused == 1);
                setReached(server.data.reached);
            }
        }
	}

    const doRefresh = async (ev : any) => {
        await getData();
        ev.detail.complete();
    };

    // go to likes
    const buyLike = () => {
        router.push("/token/wallet", "forward", "push");
    }

    // calculate the reach
    const calcReach = (amt : string) : string => {
        if (amt == "")
            return "";

        let amtInt = parseInt(amt);
        let reach = "" + Math.floor(amtInt * multiplayer);
        return reach;
    }

    // boost the post
    const boostPost = async () => {
        // check for correct amount
        let amountInt = parseInt(amount);
        if (amountInt <= 0 || amountInt > tokens)
        {
            showAlert(GetStr(LANGUAGE.TXT_INVALID_BOOST_AMT));
            return;
        }

        router.push('/boostpass/' + match.params.id + "/" + amount, "forward", "push");
    }

    // toggle the post
    const togglePause = async () => {
        setShowLoading(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: match.params.id
        }

        var server = new NServer();
        await server.sendForm("nc_boost_pause", state);
        if (!server.success && server.message != "")
        {
            setShowLoading(false);

            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            await getData();

            setShowLoading(false);
        }
    }

    // cancel the boost
    const cancelBoost = async () => {
        // ask for confirm
        let accept : ConfirmResult = await showConfirm(GetStr(LANGUAGE.TXT_BOOST_CANCEL_CAP), GetStr(LANGUAGE.TXT_BOOST_CANCEL_DESC));
        if (!accept.value)
            return;

        setShowLoading(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: match.params.id
        }

        var server = new NServer();
        await server.sendForm("nc_boost_cancel", state);
        if (!server.success && server.message != "")
        {
            setShowLoading(false);

            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            await getData();

            setShowLoading(false);
        }
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/home" ></IonBackButton>
                    </IonButtons>
                    <IonTitle className="title"><h5>{ GetStr(LANGUAGE.TXT_BOOST_CAP) }</h5></IonTitle>

                    <IonChip slot="end" onClick={buyLike}>
                        <IonIcon icon={heart} color="primary"></IonIcon>
                        <IonLabel>{ tokens }</IonLabel>
                    </IonChip>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                
                <IonGrid className="ion-no-padding full-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="10" size-lg="8" size-xl="6" size="12">
                        {
                                content.id < 20 ?
                            <div className="ion-margin spinnerCenter">
                                <IonSpinner name="crescent" />
                            </div>
                            :
                            <div>
                                <IonCard className="flat-card">
                                    <ContentMini content={content} />
                                </IonCard>
                                {
                                    boosted ?
                                /* already boosted, show boost info */
                                <IonCard className="flat-card">
                                    <IonCardHeader className="ion-text-center">
                                        <IonCardSubtitle>{ GetStr(LANGUAGE.TXT_BOOST_INIT_AMT) }</IonCardSubtitle>
                                        <IonCardTitle className="amt-medium" color="primary">
                                            { (initialAmt-amountLeft) + " / " + initialAmt }
                                            <IonProgressBar value={(initialAmt-amountLeft) / initialAmt}></IonProgressBar>
                                        </IonCardTitle>
                                        <IonCardSubtitle className="ion-margin-top">{ GetStr(LANGUAGE.TXT_BOOST_REACH) }</IonCardSubtitle>
                                        <IonCardTitle className="amt-medium" color="secondary">
                                            { reached + " / " + calcReach(""+initialAmt)  }
                                            <IonProgressBar color="secondary" value={reached / parseInt(calcReach(""+initialAmt))}></IonProgressBar>
                                        </IonCardTitle>

                                        <IonCardSubtitle className="ion-margin-top">Created: { createdTime }</IonCardSubtitle>
                                    </IonCardHeader>
                                    <IonCardContent className="ion-margin-top">
                                        {/* <IonButton className="main-but ion-margin-bottom" expand="block" onClick={togglePause} >
                                            { GetStr(paused ? LANGUAGE.TXT_BOOST_UNPAUSE : LANGUAGE.TXT_BOOST_PAUSE) }
                                        </IonButton> */}
                                        <IonButton className="main-but ion-margin-bottom" color="primary" expand="block" onClick={cancelBoost}>
                                            { GetStr(LANGUAGE.TXT_BOOST_CANCEL) }
                                        </IonButton>
                                        <IonButton className="main-but" color="secondary" expand="block" routerLink={ "/boost_report/" + match.params.id }>{ GetStr(LANGUAGE.TXT_BOOST_REPORT) }</IonButton>
                                    </IonCardContent>
                                </IonCard>
                                    :
                                /* boost settings */
                                <IonCard className="flat-card">
                                    <IonCardHeader className="ion-text-center">
                                        <IonCardSubtitle>{ GetStr(LANGUAGE.TXT_BOOST_REACH) }</IonCardSubtitle>
                                        <IonCardTitle className="amt-large" color="success">{ calcReach(amount) }</IonCardTitle>
                                    </IonCardHeader>
                                    <IonCardContent>
                                        <IonItem>
                                            <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_BOOST_AMT_LBL) }</IonLabel>
                                            <IonInput type="number" value={amount} onIonChange={ (e)=> setAmount(e.detail.value!) }></IonInput>
                                        </IonItem>
                                        <IonRange 
                                            pin={true} 
                                            max={tokens}
                                            onIonChange={ (e) => setAmount("" + e.detail.value!) }
                                        >
                                            <IonLabel slot="start">0</IonLabel>
                                            <IonLabel slot="end" >{ tokens }</IonLabel>
                                        </IonRange>
                                        <IonButton className="main-but ion-margin-bottom" expand="block" onClick={boostPost} disabled={amount==""}>{ GetStr(LANGUAGE.TXT_BOOST_BUT) }</IonButton>
                                        <IonButton className="main-but ion-margin-bottom" color="secondary" expand="block" routerLink="/ntkbuy">{ GetStr(LANGUAGE.TXT_BOOST_BUY_NTK) }</IonButton>
                                        <IonButton className="main-but" color="secondary" expand="block" routerLink={ "/boost_report/" + match.params.id }>{ GetStr(LANGUAGE.TXT_BOOST_REPORT) }</IonButton>
                                    </IonCardContent>
                                </IonCard>
                                }
                            </div>
                        }
                        <IonLoading
                            isOpen={showLoading}
                            onDidDismiss={() => setShowLoading(false)}
                            message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
                        />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};
export default BoostPost;